import { Messages } from '../../config';
import {
  ENDPOINT_APPOINTMENT_HOLIDAYS
} from '../../config/endpoints';
import { getAxios } from '../axios';
import {
  getTokenHeaders,
  addParam,
  errorCatch, getNotificationId,
} from '../helper';
import { store } from "../../store/store";
import { displayNotification } from "../../store/actions/notification";
import { NOTIFICATION_SUCCESS } from "../../store/actions/types";

/**
 * Get list of appointment holidays
 * @param {object} payload
 * @param {boolean} [payload.disablePagination]
 * @param {boolean} payload.hideNotification
 * @param {object} payload.pagination
 * @param {number} payload.pagination.page
 * @param {number} payload.pagination.per_page
 * @param {string} payload.pagination.sort_by
 * @param {string} payload.pagination.sort
 * @param {string} payload.pagination.q
 * @returns {Promise<T>}
 */
export function getAppointmentHolidays(payload) {
  if (payload && payload.disablePagination === true) {
    if (!payload.pagination) {
      payload.pagination = {};
    }

    payload.pagination.per_page = 100000;
  }

  return getAxios(payload.hideNotification).get(
    addParam(
      ENDPOINT_APPOINTMENT_HOLIDAYS,
      {
        "{appointmentHoliday}": '',
      },
    ),
    getTokenHeaders(payload.pagination || null)
  )
    .then(response => {
      return response && response.data ? response : null;
    })
    .catch(
      e => {
        errorCatch(e, {
          400: 'concat',
          401: Messages.UNAUTHENTICATED_ERROR,
          403: Messages.UNAUTHORIZED_ERROR,
          404: Messages.NOT_FOUND_ERROR,
        });

        return e.response;
      }
    );
}

/**
 * Create a appointment holiday
 * @param {object} payload
 * @param {string} payload.notificationId
 * @param {object} payload.data
 * @param {string} payload.data.day_as_timestamp
 * @param {string} payload.data.description
 * @returns {Promise<T>}
 */
export function createAppointmentHoliday(payload) {
  return getAxios().post(
      addParam(
        ENDPOINT_APPOINTMENT_HOLIDAYS,
        {
          "{appointmentHoliday}": '',
        },
      ),
      payload.data,
      getTokenHeaders()
    ).then(
      response => {
        if (response && response.status === 201) {
          store.dispatch(displayNotification(NOTIFICATION_SUCCESS, Messages.CREATE_RESOURCE_SUCCESS, payload.notificationId || null));
          return response.data;
        }

        return null;
      }
    ).catch(
      e => {
        errorCatch( e, {
          400: 'concat',
          401: Messages.UNAUTHENTICATED_ERROR,
          403: Messages.UNAUTHORIZED_ERROR,
          404: Messages.NOT_FOUND_ERROR,
        }, getNotificationId( payload ) );

        return e.response;
      }
    );
}

/**
 * Delete an appointment holiday
 * @param {object} payload
 * @param {string} payload.id
 * @param {string} payload.notificationId
 * @returns {Promise<T>}
 */
export function deleteAppointmentHoliday(payload) {
  return getAxios().delete(
    addParam(
      ENDPOINT_APPOINTMENT_HOLIDAYS,
      {
        "{appointmentHoliday}": payload.id,
      }
    ),
    getTokenHeaders()
  ).then(
    response => {
      if (response && response.status === 204) {
        store.dispatch(displayNotification(NOTIFICATION_SUCCESS, Messages.DELETE_RESOURCE_SUCCESS, payload.notificationId || null));
        return response;
      }

      return null;
    }
  ).catch(
    e => {
      errorCatch( e, {
        401: Messages.UNAUTHENTICATED_ERROR,
        403: Messages.UNAUTHORIZED_ERROR,
        404: Messages.NOT_FOUND_ERROR,
      }, getNotificationId( payload ) );

      return e.response;


    }
  );
}
